import { Type, write } from '@acorns/web-utils'
import qs from 'qs'
import { compose, equals, pathOr } from 'ramda'
import { string } from 'yup'

const REDIRECT_WHITELIST = [
  'https://app.acorns.com',
  'https://app.dev.acorns.io',
  'https://app.staging.acorns.io',
  'http://localhost:1234',
  'https://hello.dev.acorns.io',
  'https://hello.staging.acorns.io',
  'https://hello.acorns.com',
  'https://help.dev.acorns.io',
  'https://help.staging.acorns.io',
  'https://help.acorns.com',
  'https://signup.acorns.com',
  'https://signup.staging.acorns.io',
  'https://signup.dev.acorns.io',
  /^https:\/\/[\w-_]+\.app\.(dev|staging)\.acorns\.io/,
  /^https:\/\/[\w-_]+\.app\.acorns\.com/,
  /^https:\/\/[\w-_]+\.build\.(dev|staging)\.acorns\.io/,
] as ReadonlyArray<string | RegExp>

export const isTimeoutError = compose(
  equals('query_timeout'),
  pathOr(null, ['0', 'code']),
)

export const isValidEmail = (str: string = '') => {
  return string().email().isValidSync(str)
}

export const timeoutErrorDetails = {
  body: 'Sorry, we are having issues connecting to our servers. Please try again later.',
  title: 'Oops!',
}

export const isWhitelisted = (referrer: string) =>
  Boolean(
    REDIRECT_WHITELIST.find((url) => {
      if (typeof url === 'string') {
        return referrer.startsWith(url)
      }

      return Boolean(referrer.match(url))
    }),
  )

type RegistrationUrlArgs = {
  registrationUrl: string
  windowLocation: Location
}

export const registrationUrlRedirect = (
  config: RegistrationUrlArgs,
): string => {
  const parseQueryString = (queryString) => qs.parse(queryString.split('?')[1])
  const queryParams = parseQueryString(config.windowLocation.search)
  let redirectRegistrationUrl
  if (queryParams.partner && queryParams.partner.toLowerCase() === 'groupon') {
    redirectRegistrationUrl = `${
      config.registrationUrl + window.location.search
    }&s1=${queryParams.partner}`
  } else if (config.windowLocation.pathname === '/redeem') {
    redirectRegistrationUrl = `${config.registrationUrl}?gift_card=true`
  } else {
    redirectRegistrationUrl = `${config.registrationUrl}${config.windowLocation.search}`
  }
  return redirectRegistrationUrl
}
